import React from "react"
import { useQuery } from "@tanstack/react-query"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { StatsCard } from "@/components/stats-card"
import { api } from "@/lib/api"
import { BarChart3, Users, ShoppingCart, TrendingUp, Activity } from "lucide-react"

export default function AnalyticsPage() {
  const { data: revenue } = useQuery({
    queryKey: ["revenue"],
    queryFn: () => api.getRevenue(),
  })

  const { data: users } = useQuery({
    queryKey: ["users-list"],
    queryFn: () => api.getUsers(),
  })

  const { data: eventStats } = useQuery({
    queryKey: ["event-stats"],
    queryFn: () => api.getEventStats(),
  })

  const totalUsers = users?.data?.length || 0
  const totalRevenue = revenue?.data?.total || 0
  const totalEvents = eventStats?.data?.total || 0

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <BarChart3 className="h-8 w-8 text-muted-foreground" />
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Analytics</h1>
          <p className="text-muted-foreground">System analytics and insights</p>
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <StatsCard title="Total Users" value={totalUsers} icon={Users} accent="brand" />
        <StatsCard title="Revenue" value={`${totalRevenue.toLocaleString()} IRR`} icon={TrendingUp} accent="success" />
        <StatsCard title="Total Events" value={totalEvents} icon={Activity} accent="info" />
        <StatsCard title="Active Sessions" value={eventStats?.data?.active_sessions || 0} icon={ShoppingCart} accent="warning" />
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Event Breakdown</CardTitle>
        </CardHeader>
        <CardContent>
          {eventStats?.data?.by_type ? (
            <div className="space-y-2">
              {Object.entries(eventStats.data.by_type).map(([type, count]) => (
                <div key={type} className="flex items-center justify-between p-3 border rounded-lg">
                  <span className="font-medium">{type}</span>
                  <span className="text-muted-foreground">{count} events</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-muted-foreground">No event data available</p>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
